import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/transplantation-screening/lab-procedures/serumIron";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	serumIron: {
		id: "ktx.serumIron.title",
		defaultMessage: "Fe"
	},
	value: {
		id: "ktx.serumIron.field.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ktx_serumIron",
	value: {
		schemaId: "serumIron",
		title: messages.serumIron,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
